import GetDocumentsRequestModelBase from '../_generated/modelBases/get-documents-request-model-base';

export default class GetDocumentsRequestModel extends GetDocumentsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
